import * as z from "zod";

export const HangerStatusSchema = z.enum(["in-use", "ready"]);
export const HangerSchema = z.object({
  id: z.string(),
  state: HangerStatusSchema,
  hangerColor: z.string(),
  hangerArea: z.string(),
  hangerId: z.string(),
});

export type Hanger = z.infer<typeof HangerSchema>;
export type HangerStatus = z.infer<typeof HangerStatusSchema>;
